import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { StorageMap } from '@ngx-pwa/local-storage';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { StorageHelper } from './storage.helper';
import { environment } from "../../environments/environment";
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';

// var bghttp = require("nativescript-background-http");
// var session = bghttp.session("file-upload");
// import { device, screen, isAndroid, isIOS } from "tns-core-modules/platform";

// import { DeviceInfo } from 'nativescript-dna-deviceinfo';

@Injectable(
    // Instead of providers array you can use provideIn
    // Learn more https://angular.io/guide/providers
    {
        providedIn: 'root'
    }
)
export class AppService {

    storageService = new StorageHelper();

    userServiceUrl = `${environment.userService}`;
    calendarServiceUrl = `${environment.calendarService}`;
    messageServiceUrl = `${environment.messageService}`;
    baseUrl = `${environment.basePath}`;
    tenantKey = `${environment.tenantKey}`;
    applicationKey = `${environment.applicationKey}`;
    applicationReturnUrl = `${environment.applicationReturnUrl}`;
    paymentReturnUrl = `${environment.paymentReturnUrl}`;

    webPaymentReturnUrl = `${environment.webPaymentReturnUrl}`.replace('{tenantKey}', environment.tenantKey)

    addCardReturnUrl = `${environment.addCardReturnUrl}`

    google_API_key = "AIzaSyBV-kuGuSwDyejs06kyDuZ0CQa_1_ZJleQ"

    authObj;
    userId;
    accessToken = '';
    organization;

    currentCard:any
    savedCards:any = []
    userName: string;

    constructor(
        private http: HttpClient,
        private storage: StorageMap
    ) {
        // this.storage.get('authObj').subscribe((authObj: any) => {
        //     if(authObj)
        //         this.accessToken = authObj.access_token;
        // })
        this.storageService = new StorageHelper();
        this.setAuthVariables();
        // this.printDeviceInfo();
    }

    setTenantKey(tenant) {
        this.tenantKey = tenant;
    }

    setAuthVariables(authObj = null) {
        if(authObj) {
            this.authObj = authObj;
        } else {
            this.authObj = this.storageService.getItem('authObj');
        }

        if(this.authObj) {
            this.authObj = JSON.parse(this.authObj);
            console.log(this.authObj);
            if(this.authObj["id"]){
            this.userId = this.authObj["id"];
            this.storageService.setItem('userKey', this.userId);

            this.accessToken = this.authObj["access_token"];
            }
            if (this.authObj["organization"])
            {
                this.organization = this.authObj["organization"];
                localStorage.setItem("organizationKey",this.organization)
            }
            this.storageService.setItem('token', this.accessToken);

            if(this.authObj["firstName"]) {
                var user_name = this.authObj.firstName + (this.authObj.lastName ? (" " + this.authObj.lastName) : "");
                this.userName = user_name;
                this.storageService.setItem('userName', user_name);
            }


            if(this.authObj["profileAttachment"]) {
                this.storageService.setItem('userImg', this.authObj["profileAttachment"]["url"]);
            }

            if(this.authObj["tenant"]){
                this.storageService.setItem('tenant', this.authObj["tenant"]);
            }

            console.log("auth variables set");
            console.log("id",this.userId);
            console.log("name",this.authObj["firstName"]);
        } else {
            console.log("no auth obj");
            // logout
            // this.storageService.clearData();
            // this.router.navigate(['sign-in']);
        }
    }

    getMoreData(key) {
        if(this.tenantKey == "suitepaws") {
            if(key == 'callUs') return "(919) 231-1112";
            if(key == 'emailUs') return "suitepawsinfo@gmail.com";
            if(key == 'contactManager') return "suitepawsinfo@gmail.com";
            if(key == 'share') return "https://suitepaws.app.link/app";
            if(key == 'rateUs') return "https://suitepaws.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 7AM - 7PM";
            if(key == 'timings_2') return "Saturday 9AM - 5PM";
            if(key == 'timings_3') return "Sunday: 10AM - Noon, 4PM - 6PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
        }
        if(this.tenantKey == "paw-palace") {
            if(key == 'callUs') return "(404) 885-9285";
            if(key == 'emailUs') return "atlpawpalace@gmail.com";
            if(key == 'contactManager') return "atlpawpalace@gmail.com";
            if(key == 'share') return "https://pawpalace.app.link/app";
            if(key == 'rateUs') return "https://pawpalace.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 7AM - 7PM";
            if(key == 'timings_2') return "Saturday 8AM - 6PM";
            if(key == 'timings_3') return "Sunday 9AM - 3PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
        }
        if(this.tenantKey == "fidofido-alpharetta") {
            if(key == 'callUs') return "(404) 250-3920";
            if(key == 'emailUs') return "infoalpharetta@fidofido.com";
            if(key == 'contactManager') return "infoalpharetta@fidofido.com";
            if(key == 'share') return "https://fidofido.app.link/app";
            if(key == 'rateUs') return "https://fidofido.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 6:30AM - 7PM";
            if(key == 'timings_2') return "Saturday 8AM - 6PM";
            if(key == 'timings_3') return "Sunday 11AM - 6PM";
            if(key == 'terms') return "http://fidofido.com/policies-forms";
        }
        if(this.tenantKey == "dogsrus") {
            if(key == 'callUs') return "(419) 300-3647";
            if(key == 'emailUs') return "dogsrus05@gmail.com";
            if(key == 'contactManager') return "dogsrus05@gmail.com";
            if(key == 'share') return "https://dogsrus.app.link/app";
            if(key == 'rateUs') return "https://dogsrus.app.link/app";
            if(key == 'timings_1') return "Monday - Tuesday 7AM - 4PM";
            if(key == 'timings_2') return "Wednesday 8:30AM - 7PM";
            if(key == 'timings_3') return "Thursday - Friday 7AM - 4PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
        }
        if(this.tenantKey == "runloyalpetresort") {
            if(key == 'callUs') return "(404) 771-3599";
            if(key == 'emailUs') return "support@runloyal.com";
            if(key == 'contactManager') return "support@runloyal.com";
            if(key == 'share') return "https://runloyalpetresort.app.link/app";
            if(key == 'rateUs') return "https://runloyalpetresort.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 7AM - 7PM";
            if(key == 'timings_2') return "Sunday - Saturday 7:00AM - 7PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
        }
        if(this.tenantKey == "themuddymutt") {
            if(key == 'callUs') return "(703) 888-2303";
            if(key == 'emailUs') return "info@themuddymutt.com";
            if(key == 'contactManager') return "info@themuddymutt.com";
            if(key == 'share') return "https://themuddymutt.app.link/app";
            if(key == 'rateUs') return "https://themuddymutt.app.link/app";
            if(key == 'timings_1') return "Weekdays 11AM - 7PM";
            if(key == 'timings_2') return "Weekends 9AM - 7PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
        }
        if(this.tenantKey == "dogkingdom") {
            if(key == 'callUs') return "(305) 200-5985";
            if(key == 'emailUs') return "dogkingdomclub@gmail.com";
            if(key == 'contactManager') return "info@dogkingdomco.com";
            if(key == 'share') return "https://dogkingdom.app.link/app";
            if(key == 'rateUs') return "https://dogkingdom.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 7AM - 7PM";
            if(key == 'timings_2') return "Weekends 9AM - 4PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Dog Kingdom";
        }
        if(this.tenantKey == "pupncuts") {
            if(key == 'callUs') return "(404) 549-2031";
            if(key == 'emailUs') return "pupncuts@gmail.com";
            if(key == 'contactManager') return "pupncuts@gmail.com";
            if(key == 'share') return "https://pupncuts.app.link/app";
            if(key == 'rateUs') return "https://pupncuts.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 8AM - 6PM";
            if(key == 'timings_2') return "Saturday 10AM - 6PM";
            if(key == 'timings_3') return "Sunday: 10AM - 4PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Pup-N-Cuts";
        }
        if(this.tenantKey == "pawpack") {

            if(key == 'share') return "https://pawpack.app.link/app";
            if(key == 'rateUs') return "https://pawpack.app.link/app";

        }
        if(this.tenantKey == "pawease") {

            if(key == 'share') return "https://pawease.app.link/app";
            if(key == 'rateUs') return "https://pawease.app.link/app";
        }
        if(this.tenantKey == "dogspaw") {
            if(key == 'callUs') return "(419) 733-5245";
            if(key == 'emailUs') return "thedogspaw16@gmail.com";
            if(key == 'contactManager') return "thedogspaw16@gmail.com";
            if(key == 'share') return "https://dogspaw.app.link/app";
            if(key == 'rateUs') return "https://dogspaw.app.link/app";
            if(key == 'timings_1') return "Monday 8AM - 6PM";
            if(key == 'timings_2') return "Tuesday 9AM - 6PM (By appt. only)";
            if(key == 'timings_3') return "Wednesday 7AM - 6PM";
            if(key == 'timings_4') return "Thursday 7AM - 6PM";
            if(key == 'timings_5') return "Friday 9AM - 6PM";
            if(key == 'timings_6') return "Saturday 9AM - 12NOON";
            if(key == 'timings_7') return "Sunday 3AM - 6PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "THe Dog Spaw";
        }
        if(this.tenantKey == "thehoundry") {
            if(key == 'callUs') return "(865) 272-6540";
            if(key == 'emailUs') return "info@playatthehoundry.com";
            if(key == 'contactManager') return "info@playatthehoundry.com";
            if(key == 'share') return "https://thehoundry.app.link/app";
            if(key == 'rateUs') return "https://thehoundry.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 7AM - 7PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "The Houndry";
        }
        if(this.tenantKey == "weststreetdog") {
            // if(key == 'callUs') return "(865) 272-6540";
            // if(key == 'emailUs') return "info@playatthehoundry.com";
            // if(key == 'contactManager') return "info@playatthehoundry.com";
            if(key == 'share') return "https://weststreetdog.app.link/app";
            if(key == 'rateUs') return "https://weststreetdog.app.link/app";
            // if(key == 'timings_1') return "Monday - Friday 7AM - 7PM";
            // if(key == 'terms') return "https://www.runloyal.com/terms/";
            // if(key == 'appName') return "The Houndry";
        }
        if(this.tenantKey == "amopetcare") {
            if(key == 'callUs') return "(319) 512-5054";
            if(key == 'emailUs') return "amo.petcare@gmail.com";
            if(key == 'contactManager') return "amo.petcare@gmail.com";
            if(key == 'share') return "https://amopetcare.app.link/app";
            if(key == 'rateUs') return "https://amopetcare.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 8AM - 11PM";
            if(key == 'timings_2') return "Saturday - Sunday 8AM - 11PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "AMO Pet Care";
        }
        if(this.tenantKey == "nycpetdirect") {
            if(key == 'callUs') return "(718) 963-4030";
            if(key == 'emailUs') return "nycpetdirect@optonline.net";
            if(key == 'contactManager') return "nycpetdirect@optonline.net";
            if(key == 'share') return "https://nycpetdirect.app.link/app";
            if(key == 'rateUs') return "https://nycpetdirect.app.link/app";
            if(key == 'timings_1') return "Monday - Saturday 11AM - 7PM";
            if(key == 'timings_2') return "Sunday 12PM - 5PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "NYC Pet Direct";
        }
        if(this.tenantKey == "gooddogs") {
            if(key == 'callUs') return "(704) 402-9725";
            if(key == 'emailUs') return "info@traingooddogs.com";
            if(key == 'contactManager') return "info@traingooddogs.com";
            if(key == 'share') return "https://gooddogs.app.link/app";
            if(key == 'rateUs') return "https://gooddogs.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 9AM - 7PM";
            if(key == 'timings_2') return "Weekends 9AM - 4PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Good Dogs";
        }
        if(this.tenantKey == "barkandboarding") {
            if(key == 'callUs') return "(202) 949-7275";
            if(key == 'emailUs') return "erin@barkandboarding.com";
            if(key == 'contactManager') return "erin@barkandboarding.com";
            if(key == 'share') return "https://barkandboarding.app.link/app";
            if(key == 'rateUs') return "https://barkandboarding.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 6:30AM - 7:30PM";
            if(key == 'timings_2') return "Saturday 10AM - 7:30PM";
            if(key == 'timings_3') return "Sunday 10AM - 5PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Bark + Boarding";
        }
        if(this.tenantKey == "pawsandpamper") {
            if(key == 'callUs') return "(406) 552-2157";
            if(key == 'emailUs') return "pawsandpampermt@gmail.com";
            if(key == 'contactManager') return "pawsandpampermt@gmail.com";
            if(key == 'share') return "https://pawsandpamper.app.link/app";
            if(key == 'rateUs') return "https://pawsandpamper.app.link/app";
            if(key == 'timings_1') return "Monday : Closed";
            if(key == 'timings_2') return "Tuesday - Saurday 9AM - 4PM";
            if(key == 'timings_3') return "Sunday : Closed";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Paws and Pamper";
        }
        if(this.tenantKey == "weststreetdog") {
            if(key == 'callUs') return "(919) 231-1112";
            if(key == 'emailUs') return "suitepawsinfo@gmail.com";
            if(key == 'contactManager') return "suitepawsinfo@gmail.com";
            if(key == 'share') return "https://weststreetdog.app.link/app";
            if(key == 'rateUs') return "https://weststreetdog.app.link/app";
            if(key == 'timings_1') return "Monday - Friday 7AM - 7PM";
            if(key == 'timings_2') return "Saturday 9AM - 5PM";
            if(key == 'timings_3') return "Sunday: 10AM - Noon, 4PM - 6PM";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "West St. Dog";
        }
        if(this.tenantKey == "sitstay") {
            if(key == 'callUs') return "(203) 499-8531";
            if(key == 'emailUs') return "sitstayct@yahoo.com";
            if(key == 'contactManager') return "sitstayct@yahoo.com";
            if(key == 'share') return "https://sitstay.app.link/app";
            if(key == 'rateUs') return "https://sitstay.app.link/app";
            if(key == 'timings_1') return "Sunday - Saturday 6am - 9pm";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Sit Stay";
        }
        if(this.tenantKey == "preciouspaws") {
            if(key == 'callUs') return "(770) 684-2248";
            if(key == 'emailUs') return "info@preciouspawsga.com";
            if(key == 'contactManager') return "info@preciouspawsga.com";
            if(key == 'share') return "https://preciouspaws.app.link/app";
            if(key == 'rateUs') return "https://preciouspaws.app.link/app";
            if(key == 'timings_1') return "Mon-Sat 8am-6pm";
            if(key == 'timings_2') return "Sun 3pm-5pm";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Precious Paws";
        }
        if(this.tenantKey == "atlantapetcarecenter") {
            if(key == 'callUs') return "(404) 299-5551";
            if(key == 'emailUs') return "atlantapetcarecenter2013@gmai.com";
            if(key == 'contactManager') return "atlantapetcarecenter2013@gmai.com";
            if(key == 'share') return "https://atlantapetcarecenter.app.link/app";
            if(key == 'rateUs') return "https://atlantapetcarecenter.app.link/app";
            if(key == 'timings_1') return "MON-FRI 7:00 am - 7:00 pm";
            if(key == 'timings_2') return "SAT 8:00 am - 12:00 pm";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Atlanta Pet Care Center";
        }
        if(this.tenantKey == "opiesoutpost") {
            if(key == 'callUs') return "(203) 499-8531";
            if(key == 'emailUs') return "opiesoutpost@gmail.com";
            if(key == 'contactManager') return "opiesoutpost@gmail.com";
            if(key == 'share') return "https://opiesoutpost.app.link/app";
            if(key == 'rateUs') return "https://opiesoutpost.app.link/app";
            if(key == 'timings_1') return "Monday - Friday  8am- 6pm";
            if(key == 'timings_2') return "Saturday 10am-6pm";
            if(key == 'timings_3') return "Sunday 10am - 4pm";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Opies Outpost";
        }
        if (this.tenantKey == 'dejasdoggiecamp')
        {
            if(key == 'callUs') return "(763) 213-1498";
            if(key == 'emailUs') return "dejasdoggiecamp@msn.com";
            if(key == 'contactManager') return "dejasdoggiecamp@msn.com";
            if(key == 'share') return "https://dejasdoggiecamp.app.link/app";
            if(key == 'rateUs') return "https://dejasdoggiecamp.app.link/app";
            if(key == 'timings_1') return "Monday - Saturday 8am-6pm";
            if(key == 'terms') return "https://www.runloyal.com/terms/";
            if(key == 'appName') return "Deja’s Doggie Camp";
        }
    }

    async printDeviceInfo() {
        // console.log("Free memory: ", this.formatBytes(DeviceInfo.freeMemory()));
        // console.log("Total memory: ", this.formatBytes(DeviceInfo.totalMemory()));
        // console.log("Total storage space: ", this.formatBytes(DeviceInfo.totalStorageSpace()));
        // console.log("Free storage space: ",this.formatBytes(DeviceInfo.freeStorageSpace()));
        // console.log("Device id: ", DeviceInfo.deviceId());
        // console.log("Device name: ",  DeviceInfo.deviceName());
        // console.log("Device locale: ", DeviceInfo.deviceLocale());
        // console.log("Device country: ", DeviceInfo.deviceCountry());
        // console.log("Device timezone: ", DeviceInfo.timezone());
        // // console.log("Device user agent: ", DeviceInfo.userAgent());
        // console.log("App name: ", DeviceInfo.appName());
        // console.log("App version: ", DeviceInfo.appVersion());
        // console.log("App bundle id: ", DeviceInfo.bundleId());
        // console.log("App bundle number: ", DeviceInfo.bundleNumber());
        // console.log("System manufacturer: ",  DeviceInfo.systemManufacturer());
        // console.log("Battery level: ",  Math.round(DeviceInfo.batteryLevel()));
        // console.log("Storage paths: ", DeviceInfo.externalStoragePaths());
        // console.log("Storage volume info: ", DeviceInfo.storageVolumes());
        // console.log("WiFi SSID: ", DeviceInfo.wifiSSID());
        // console.log("Display metrics: ", DeviceInfo.displayMetrics());
        // console.log("Is portrait orientation: ", DeviceInfo.isPortrait());
        // console.log("Is tablet: ", DeviceInfo.isTablet());
        // console.log("Is 24 hour: ", DeviceInfo.is24Hour());
        // console.log("Is emulator: ", DeviceInfo.isEmulator());
        // console.log("Is battery charing: ",  DeviceInfo.isBatteryCharging());
        // console.log("Is Location service enabled: ", await DeviceInfo.isLocationEnabled().catch(error => console.log(error)));
        // console.log("Is Bluetooth enabled: ", await DeviceInfo.isBluetoothEnabled().catch(error => console.log(error)));
    }

    formatBytes(bytes, decimals = null) {
      if (bytes === 0) return '0 GB'
      if (isNaN(parseInt(bytes))) return bytes
      if (typeof bytes === 'string') bytes = parseInt(bytes)
      if (bytes === 0) return '0';
      const k = 1000;
      const dm = decimals + 1 || 3;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
    }

    getLocationPreference() {
        let locUrl = this.userServiceUrl + "/users/" + this.userId + "/preference";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getLocations() {
        let locUrl = this.userServiceUrl + "/kennel/" + this.tenantKey + "/locations";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getTenant_external(serverName) {
        let locUrl = this.userServiceUrl + "/api/v2/external/location?serverName=" + serverName;
        let headers = new HttpHeaders({
            // "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getTenant_external_aspromise(serverName) {
        let locUrl = this.userServiceUrl + "/api/v2/external/location?serverName=" + serverName;
        let headers = new HttpHeaders({
            // "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers}).toPromise()
    }

    getTenantDetail(tenantKey) {
        let locUrl = this.userServiceUrl + "/api/v3/external/tenant-setting/" + tenantKey + "/PORTAL";
        let headers = new HttpHeaders({
            // "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }
    getVersion(tenantKey){
        let locUrl = this.userServiceUrl + "/version/"+ tenantKey +"/WEB/1.104";
        let headers = new HttpHeaders({
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }
    getLocations_external(serverName) {
        let locUrl = this.userServiceUrl + "/api/v2/external/location?serverName=" + serverName;
        let headers = new HttpHeaders({
            // "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getMultiLocations(){
        let locUrl = this.userServiceUrl + '/api/v3/organization?' + 'domainName=' + this.tenantKey
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getMultiLocationsAsPromise(domainName){
        let locUrl = this.userServiceUrl + '/api/v3/organization?' + 'domainName=' + domainName
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers}).toPromise()
    }

    getNotifications() {
        let locUrl = this.baseUrl + "/notification-service/notification/" + this.userId + "?read=false&allRecords=true";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getUserDetails() {
        let locUrl = this.userServiceUrl + "/users/" + this.userId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

     updatePhoneNumber(phoneNumber: string, userKey: string) {
        let locUrl = this.userServiceUrl +"/users/" + userKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        let payload = {mobileNumber:phoneNumber,tenantKey:this.tenantKey};
        return this.http.put(locUrl,payload,{headers : headers})
    }

    checkForAgreements(serviceTypeId, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/userAgreement/agreementRequired/" + "?serviceId=" + serviceTypeId + "&petKey=" + petKey + "&userKey=" + this.userId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getUserAgreements() {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/userAgreement/user/" + this.userId
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        //  alert(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getAgreementsForService(serviceIdString, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/userAgreement/user/" + this.userId + "?serviceId=" + serviceIdString + "&petKey=" + petKey + "&type=" + "WEB";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        //  alert(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    acceptAgreement(agreementBody, agreementId) {
        agreementBody["appointmentSource"] = "WEB";

        let url;

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        if(agreementId) {
            url = this.userServiceUrl + "/api/v2/"+ this.tenantKey +"/" + this.storageService.getItem("locationKey") + "/userAgreement/" + agreementId;

            return this.http.put(url, agreementBody, { headers: headers })
            .pipe(
                map((res:Response) => res),
                catchError((error:any) => throwError(error || 'Server error'))
            )
        } else {
            url = this.userServiceUrl + "/api/v2/"+ this.tenantKey +"/" + this.storageService.getItem("locationKey") + "/userAgreement";

            return this.http.post(url, agreementBody, { headers: headers })
            .pipe(
                map((res:Response) => res),
                catchError((error:any) => throwError(error || 'Server error'))
            )
        }
    }

    saveUserDetails(user) {
        user["tenantKey"] = this.tenantKey;
        let locUrl = this.userServiceUrl + "/users/" + this.userId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.put(locUrl, user, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    setLocationPreference(locationKey) {
        let body = {
            "pushNotification": false,
            "sms": false,
            "email": false,
            "preferredLocation": {
                "locationKey": locationKey
            }
        };
        let locUrl = this.userServiceUrl + "/users/"+ this.userId +"/preference";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    saveEmergencyContact(body) {
        let locUrl = this.userServiceUrl + "/users/"+ this.userId +"/preference/location";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    saveUserAddress(body) {
        let locUrl = this.userServiceUrl + "/users/"+ this.userId +"/address";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getUserPets(userId = null) {
        let locUrl = this.userServiceUrl + "/pets/" + this.tenantKey + "/pets/" + (userId ? userId : this.userId);
        console.log(this.accessToken)
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getReservationTypes(date) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/reservation?active=true&serviceDate="+date;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getReservationTypesByPetType(petTypeId ,locationKey = null, date) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/reservation/petType/"+ petTypeId+"?active=true&serviceDate="+date;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getMessages() {
        let locUrl = this.baseUrl + "/message-service/conversation/participant/PETOWNER/" + this.userId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getVideos() {
        let locUrl = this.baseUrl + "/message-service/conversation/participant/PETOWNER/" + this.userId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getAppointments() {
        let locUrl = this.userServiceUrl + "/appointment/" + this.tenantKey + "/" + this.userId + "/user";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getAppointmentObj(appointmentKey) {
        let locUrl = this.userServiceUrl + "/appointment/" + this.tenantKey + "/" + appointmentKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getFilteredAppointments(type) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/appointment/user/" + this.userId + "?sort=appointmentDate,desc&size=50&page=0&appointmentCriteria=" + type;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPetDetails(petKey) {
        let locUrl = this.userServiceUrl + "/pets/" + this.tenantKey + "/pets/" + this.userId + "/pet/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });

        console.log(locUrl);

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getUniversalLink(userId) {
        let locUrl = this.userServiceUrl + "/invite/user/" + (userId ? userId : this.userId);
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    checkInviteCode(inviteCode) {
        let locUrl = this.userServiceUrl + "/invite/" + this.tenantKey + "/" + inviteCode;
        let headers = new HttpHeaders({
            "Content-Type": "application/json",
         });
         console.log(locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    submitPasswordForInviteCode(request){
        let locUrl = this.userServiceUrl + "/invite"
        let headers = new HttpHeaders({
            "Content-Type": "application/json",
         });

        return this.http.put(locUrl, request, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPetType(locationKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/petType";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPetType_external(locationKey,date) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/external/petType?active=true&serviceDate="+date;
        let headers = new HttpHeaders({
            // "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    addCard(userKey, userInfo){
        let locUrl = "https://uat.pawops.com/services/payment-service/api/iTrust-PawOps/merchant/" + this.tenantKey + "/customer/" + userKey + "/addCard"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

         return this.http.post(locUrl, userInfo, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPetBreed(petTypeId, locationKey = null) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/petType/" + petTypeId + "/breeds?pageNumber=0&size=2000";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPetSize(petTypeId) {
        let locUrl = this.userServiceUrl + "/pets/" + this.tenantKey + "/sizesByPetType/" + petTypeId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPetGender(petTypeId, locationKey = null) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/petType/" + petTypeId + "/petGender";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPetImageUploadUrl(image) {
        var extension = image.extension.split(".")[1];
        let locUrl = this.userServiceUrl + "/document/uploadUrl/?id=" + this.userId + "&uploadType=PET&filename="+ image.name +"&mimeType=image/" + extension;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getUserImageUploadUrl(image) {
        var extension = image.extension.split(".")[1];
        let locUrl = this.userServiceUrl + "/document/uploadUrl/?id=" + this.userId + "&uploadType=PROFILE&filename="+ image.name +"&mimeType=image/" + extension;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getChatImageUploadUrl(image, id) {
        var extension = image.extension.split(".")[1];
        let locUrl = this.userServiceUrl + "/document/uploadUrl/?id=" + id + "&uploadType=CHAT&filename="+ image.name +"&mimeType=image/" + extension;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getImmunizationImageUploadUrl(image) {
        var extension = image.extension.split(".")[1];
        let locUrl = this.userServiceUrl + "/document/uploadUrl/?id=" + this.userId + "&uploadType=PET_IMMUNIZATION&filename="+ image.name +"&mimeType=image/" + extension;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getImmunizationImageUrl(image) {
        var extension = image.mimeType.split(".")[1];
        let locUrl = this.userServiceUrl + "/document/downloadUrl/?id=" + this.userId + "&uploadType=PET_IMMUNIZATION&filename="+ image.physicalFilename +"&mimeType=image/" + extension;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    uploadImageToAws(url, image, image64) {
        var extension = image.extension.split(".")[1];

        return new Promise<String>((resolve, reject) => {

            // var request = {
            //     url: url,
            //     method: "PUT",
            //     headers: {
            //         // "Content-Type": "application/octet-stream",
            //         "File-Name": image.name,
            //         "Content-Type": "image/" + extension,
            //         "x-amz-acl": 'public-read'
            //     },
            //     description: "{ 'uploading': file.name }"
            // };

            // var task = session.uploadFile(image.path, request);

            // task.on("progress", logEvent);
            // task.on("error", logEvent);
            // task.on("complete", logEvent);

            // function logEvent(e) {
            //     // console.log(e);
            // }

        });
    }

    addPet(petObj, userId = null) {
        petObj["user"]["userKey"] = userId ? userId : this.userId;
        petObj["tenant"]["tenantKey"] = this.tenantKey;

        let url = this.userServiceUrl + "/pets/"+ this.tenantKey +"/add-pet";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(url);

        return this.http.post(url, petObj, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    editPet(petObj) {
        let url = this.userServiceUrl + "/pets/"+ this.tenantKey +"/save-pet";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(url);

        return this.http.put(url, petObj, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }
    getCalendarHolidays_new(calendarKey) {
        let locationKey = JSON.parse(this.storageService.getItem("locationKey"))
        let locUrl = this.calendarServiceUrl + "/api/" + this.applicationKey + "/" + locationKey + "/calendar/" + calendarKey + "/calendarSchedule";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

         console.log("getCalendarDates", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }
    getCalendarDates(startDate, endDate, locationKey, calendarKey) {
        let locUrl = this.calendarServiceUrl + "/api/" + this.applicationKey + "/scheduler?calendarType=BASECALENDAR&calendarKey=" + calendarKey + "&endDate=" + endDate +  "&startDate=" + startDate + "&subjectKey=" + locationKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

         console.log("getCalendarDates", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getCalendarDates_new(startDate, calendarKey, timezone, endDate=null) {
        // let locUrl = this.calendarServiceUrl + "/external/api/" + this.applicationKey + "/" + calendarKey + "/resource/calendarSchedule?startDate=" + startDate + "&timeZone=" + timezone;
        let locUrl = this.calendarServiceUrl + "/external/api/" + this.applicationKey + "/" + calendarKey + "/resource/calendarSchedule?startDate=" + startDate;

        if(endDate != null){
            locUrl = locUrl + "&endDate=" + endDate + "&timeZone=" + timezone
        }else{
            locUrl = locUrl + "&timeZone=" + timezone
        }

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

         console.log("getCalendarDates", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getServiceTimings(locationKey, calendarKey) {
        let locUrl = this.calendarServiceUrl + "/api/" + this.applicationKey + "/" + locationKey + "/calendar/" + calendarKey +  "/calendarSchedule?size=50";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + (this.accessToken ? this.accessToken : localStorage.getItem("token")),
            "Content-Type": "application/json",
         });

        console.log("getServiceTimings", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getInOutTimings(locationKey, calendarKey) {
        let locUrl = this.calendarServiceUrl + "/api/" + this.applicationKey + "/" + locationKey + "/calendar/" + calendarKey +  "/calendarSchedule?size=50";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + (this.accessToken ? this.accessToken : localStorage.getItem("token")),
            "Content-Type": "application/json",
         });

        console.log("getInOutTimings", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getSlotsForDate(startDate, endDate, locationKey, serviceId) {
        // let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/employee/availableSlots?&endDate=" + endDate +  "&startDate=" + startDate + "&serviceId=" + serviceId + "&includeEvents=true";
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/employee/availableSlots?endDate=" + endDate +  "&startDate=" + startDate + "&serviceId=" + serviceId +"&includeEvents=true";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getSlotsForDate_capacity(startDate, endDate, participantParams, serviceId, calendarKey) {
        let locUrl = this.calendarServiceUrl + "/api/" + this.applicationKey + "/scheduler?calendarType=BASECALENDAR&subjectKey=" + serviceId + "&endDate=" + endDate +  "&calendarKey=" + calendarKey + "&startDate=" + startDate + "&" + participantParams + "&participantType=LODGE";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log("scheduler api with partispantids:", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getSlotsForDateCapacity(locationKey, serviceId) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/lodgeByServiceId/"+serviceId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log("getSlotsForDateCapacity - lodgeByServiceId", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getAppProfile(orgKey) {
      let locUrl = this.userServiceUrl + "/api/v3/external/"+orgKey + "/" + this.tenantKey + "/app-profile-setting?size=500&platform=WEB";
      let headers = new HttpHeaders({
         // "authorization": "Bearer " + this.accessToken,
          "Content-Type": "application/json",
       });
      return this.http.get(locUrl, {headers : headers})

  }

    bookAppointment(appointmentObj, userId = null) {
        let url = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + appointmentObj.location.locationKey + "/appointment/" + (userId ? userId : this.userId);
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.post(url, appointmentObj, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    bookAppointmentNew(appointmentObj, userId = null) {
        let url = this.userServiceUrl + "/api/v3/" + this.tenantKey + "/appointment/" + (userId ? userId : this.userId);

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.post(url, appointmentObj, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getUsersForMessages() {
        let locUrl = this.userServiceUrl + "/kennel/" + this.tenantKey + "/locations";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log("getSlotsForDateCapacity - lodgeByServiceId", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createConversation(chatobj) {
        let url = this.messageServiceUrl + "/conversation";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.post(url, chatobj, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getConversationMessages(conversationId) {
        let locUrl = this.messageServiceUrl + "/message/conversation/" + conversationId + "?sort=createdOn,desc&size=20&pageNumber=0";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log("getSlotsForDateCapacity - lodgeByServiceId", locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    sendMessage(messageobj) {
        let url = this.messageServiceUrl + "/message";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.post(url, messageobj, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getInvoiceDetails(appointmentKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/invoice/appointment/" + appointmentKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPaymentLink(body, estNo) {
        let url = this.baseUrl + "/payment-service/api/" + this.applicationKey + "/merchant/" + this.tenantKey + "/" + estNo + "/payment";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.post(url, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getSavedCards() {
        let locUrl = this.baseUrl + "/payment-service/api/" + this.applicationKey + "/merchant/" + this.tenantKey + "/customer/" + this.userId + "/cards";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    iamHere(notes, isPickUp) {
        var body = {
            "imHereMsg" : notes,
        }
        if(!isPickUp) {
            isPickUp = false;
        }
        let url = this.userServiceUrl + "/api/v2/"+ this.tenantKey +"/" + this.storageService.getItem("locationKey") + "/appointment/imHereNotification/" + this.userId + "?pickup=" + isPickUp + "&call=true";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        //  alert(url);

        return this.http.post(url, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    addAttachments(attachments, documentId) {
        let url = this.userServiceUrl + "/document/"+ documentId +"/attachment";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

         var body = {
             "list" : attachments
         }
        return this.http.post(url, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createDocument(body) {
        body["userKey"] = this.userId;
        // body["userId"] = this.userId;
        let url = this.userServiceUrl + "/document";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(url, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getGalleryImages(pageNo, pageSize) {
        let locUrl = this.userServiceUrl + "/document/" + this.userId + "/gallery";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getImmunizations(petKey) {
        let locUrl = this.userServiceUrl + "/pets/" + this.tenantKey + "/immunization/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getImmunizationsType(pet) {
        // https://www.runloyal.com/services/user-service/api/v2/runloyalpetresort/%22TN07loC01%22/petType/18/petImmunizationType
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petType/" + pet.type.id + "/petImmunizationType";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createImmunization(body, petKey) {
        let locUrl = this.userServiceUrl + "/pets/" + this.tenantKey + "/immunization/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    notificationSeen(body) {
        let locUrl = this.baseUrl + "/notification-service/notification/" + this.userId + "/read";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.put(locUrl, body, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getReviewParameters() {
        let locUrl = this.userServiceUrl + "/review/" + this.tenantKey + "/parameter/" + this.storageService.getItem("locationKey") + "/APPOINTMENT";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    reviewAppointment(body, reviewId) {
        let locUrl = this.userServiceUrl + "/review/" + this.tenantKey + "/" + reviewId;

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.put(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getDirections(origin, destination) {
        let APIURL = `https://maps.googleapis.com/maps/api/directions/json`;
        APIURL += `?origin=${origin.latitude},${origin.longitude}`;
        APIURL += `&destination=${destination.latitude},${destination.longitude}`;
        APIURL += `&key=${this.google_API_key}`;

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(APIURL);
        return this.http.get(APIURL, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getDistance(origin, destination) {
        let distanceMatrixAPIURL = "https://maps.googleapis.com/maps/api/distancematrix/json?units=metric&";
        distanceMatrixAPIURL += `origins=${origin.latitude},${origin.longitude}&destinations=${destination.latitude},${destination.longitude}&key=${this.google_API_key}`;

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(distanceMatrixAPIURL);
        return this.http.get(distanceMatrixAPIURL, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    startForAppointment(body, appointmentKey) {
        let locUrl = this.userServiceUrl + "/appointment/"+ this.tenantKey +"/"+ this.userId +"/" + appointmentKey + "/status";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.put(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getAvailablePackages(type) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/" + this.userId + "/packages?pageNumber=0&size=2000&active=true&type=" + type;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPurchasedPackages(type) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/" + this.userId + "/packageSubscriptions/user?type=" + type;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    updateUserEmail(email) {
        var body = {
            "userKey": this.userId,
            "email": email
        }
        let locUrl = this.userServiceUrl + "/users/tenant/" + this.tenantKey + "/" + this.userId + '/reset/initiate/userName';
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    resendEmail() {
        var body = {
            "userKey": this.userId,
            "sendResetMailOnly":true
        }
        let locUrl = this.userServiceUrl + "/users/tenant/" + this.tenantKey + "/" + this.userId + '/reset/initiate/userName';
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createInvoice(body) {
        let locUrl = this.baseUrl + "/payment-service/api/" + this.applicationKey + "/merchant/" + this.tenantKey + "/customer/" + this.userId + "/invoice";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }



    getAllergies(petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/" + petKey + "/petAllergy";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getAllergyTypes() {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/allergyTypes";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createAllergy(body, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petAllergy/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    deleteAllergy(allergyId) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petAllergy/" + allergyId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.delete(locUrl, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getDailyRoutine(petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/" + petKey + "/petRoutine";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createDailyRoutine(body, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petRoutine/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    deleteDailyRoutine(routineId) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petRoutine/" + routineId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.delete(locUrl, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPetTraining(petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/" + petKey + "/petTraining";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createPetTraining(body, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petTraining/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    deletePetTraining(petTrainingId) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petTraining/" + petTrainingId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.delete(locUrl, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getBehavior(petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/" + petKey + "/petBehavior";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getBehaviorOptions(petTypeId) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petType/" + petTypeId + "/temperament";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createBehavior(body, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petBehavior/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    updateBehavior(body, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petBehavior/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.put(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    deleteBehavior(petBehaviourId) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petBehavior/" + petBehaviourId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.delete(locUrl, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getMedicalHistory(petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/" + petKey + "/petMedicalHistory";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getMedicalHistoryPreventionOptions() {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/prevention";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createMedicalHistory(body, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petMedicalHistory/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    updateMedicalHistory(body, petKey) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petMedicalHistory/" + petKey;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.put(locUrl, body, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    deleteMedicalHistory(medicalHistoryId) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petMedicalHistory/" + medicalHistoryId;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.delete(locUrl, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    agreementOne(id: any){
        let url =  environment.agreementOneUrl + "/document/uploadUrl?mimeType=image/png&filename=signature.png&uploadType=USER_AGREEMENT&id=" + id

        return this.http.get(url)
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    agreementTwo(url:string, file:File){
        let headers = new HttpHeaders({
            "File-Name": 'signature.png',
            "content-type": 'image/png',
            "x-amz-acl": "public-read",
         });

        return this.http.put(url, file, { headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    newAgreementOne(file: File, id: any){
        let userKey = localStorage.getItem('userKey').replace(/['"]/g, '');
        let url =  environment.agreementOneUrl + "/document/webUploadUrl?uploadType=USER_AGREEMENT&filename=" + file.name + "&mimeType=" + file.type + "&id=" + id

        let formData = new FormData();
        formData.append('file', file);

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
         });

        return this.http.post(url, formData, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    agreementThree(id:any, fileName:string, physicalFileName:string,signedBy:string){
        // let url =  `${environment.agreementThreeUrl}`.replace('{tenantKey}', environment.tenantKey) + '/' + id + '?filename=' + fileName + '&physicalFileName=' +  physicalFileName + '&uploadType=USER_AGREEMENT&'+ 'id=' + id + '&mimeType=image/png'
        let url = this.userServiceUrl + "/api/v3/external/document/signAgreement?filename="+fileName+"&physicalFileName="+physicalFileName+"&uploadType=USER_AGREEMENT&mimeType=image/png&id="+ id +"&signedBy="+signedBy
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(url, {headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getAgreements(serviceId:any[], petKey:any[]){
        let locationKey = localStorage.getItem("locationKey")
        locationKey = locationKey.includes('"') ? locationKey.replace(/\"/g, "") : locationKey

        let url = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/userAgreement/user/" + this.userId + "?serviceId=" + serviceId + "&petKey=" + petKey + "&type=WEB"

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(url, {headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getImmunizationsForPet(petKey:string){
        let locUrl = this.userServiceUrl + "/pets/" + this.tenantKey + "/immunization/" + petKey + "?sort=createdOn,desc"

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getImmunizationsForPetType(type) {
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + this.storageService.getItem("locationKey") + "/petType/" + type + "/petImmunizationType";
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    addImmunization(petKey:string, request:any){
        let locUrl =  this.userServiceUrl + "/pets/" + this.tenantKey + "/immunizations/" + petKey
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
        return this.http.post(locUrl, request, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    uploadImmunizationCall(name:any, type:any, petKey:string){
        let locUrl = this.userServiceUrl + "/document/uploadUrl/?id=" + petKey + "&uploadType=PET_IMMUNIZATION&filename=" + name + "&mimeType=" + type;

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    uploadImmunizationDocument(url:string, file:File, type:string){
        let headers = new HttpHeaders({
            "Content-Type": type,
            "x-amz-acl": "public-read"
        });

        return this.http.put(url, file, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }
    // New function for immunization call with new API
    newUploadImmunizationCall(file: File, petKey:string){
        let userKey = localStorage.getItem('userKey').replace(/['"]/g, '');
        let locUrl = this.userServiceUrl + "/document/webUploadUrl?uploadType=PET_IMMUNIZATION&filename=" + file.name + "&mimeType=" + file.type + "&id=" + petKey;

        let formData = new FormData();
        formData.append('file', file);

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
         });

        return this.http.post(locUrl, formData, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    addAttachment(documentId:any, request:any){
        let locUrl = this.userServiceUrl + "/document/" + documentId  + "/attachment"

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.post(locUrl, request, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getGroupAddOnServices(organizationKey:any){
        let locUrl = this.userServiceUrl + "/api/v3/" + organizationKey + "/" + this.tenantKey + "/service-group"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    generateIdForAgreement(request, agreementId){
        let tenantKey = localStorage.getItem("tenant")
        tenantKey = tenantKey && tenantKey.includes('"') ? JSON.parse(localStorage.getItem("tenant")) : tenantKey
        let locationKey = localStorage.getItem("locationKey")
        locationKey = locationKey.includes('"') ? JSON.parse(localStorage.getItem("locationKey")) : locationKey

        let locUrl = this.userServiceUrl + "/api/v2/" + tenantKey + "/" + locationKey + "/userAgreement"

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.post(locUrl, request, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getLinkedServiceQuestion(serviceId){
        let locUrl =   this.userServiceUrl +  "/api/v3/"+ this.organization +"/"+ this.tenantKey +"/"+this.userId+"/affiliated-tenants/linkService/reservationTypeQuestions/"+ serviceId
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getLodgingSlots(serviceID){

        let locationKey = localStorage.getItem("locationKey")
        locationKey = locationKey.includes('"') ? JSON.parse(localStorage.getItem("locationKey")) : locationKey

        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/lodgeByServiceId/" + serviceID 
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getUserDetailByUserKey(userKey){
        let locUrl = this.userServiceUrl + "/admin/v1/" + this.tenantKey + "/users/" + userKey
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    updateUserAddress(data,userKey){
        let locUrl = this.userServiceUrl +"/users/" + userKey + "/address"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.post(locUrl, data, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )

    }

    getMembershipExternal(){
        let locationKey = JSON.parse(this.storageService.getItem("locationKey"))
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/external/memberships?active=true&size=500"
        let headers = new HttpHeaders({
            "authorization": "Bearer "  + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getPackageExternal(){
        let locationKey = JSON.parse(this.storageService.getItem("locationKey"))
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/external/packages?active=true&type=PACKAGE&size=500"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    updatePet(request){
        let url = this.userServiceUrl + "/pets/"+ this.tenantKey +"/save-pet";  
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });
         console.log(url);

        return this.http.put(url, request, { headers: headers })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getMembershipAgreement(param){
        let locationKey = this.storageService.getItem("locationKey");
        if(locationKey.includes('"')){
            locationKey = JSON.parse(locationKey)
        }
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/userAgreement/user/" + this.userId + param 

        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
         });

        return this.http.get(locUrl, {headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    createMembershipSubscription(request){
        let locationKey = this.storageService.getItem("locationKey");
        if(locationKey.includes('"')){
            locationKey = JSON.parse(locationKey)
        }
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey +'/' + this.userId + "/membershipSubscriptions"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });

        return this.http.post(locUrl, request, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    createSubscription(request){
        let locUrl = this.baseUrl + "/payment-service/api/" + this.applicationKey + "/merchant/" + this.tenantKey + "/subscription"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.post(locUrl, request, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    createQCInvoice(request){
        let locUrl = this.baseUrl + "/payment-service/api/" + this.applicationKey + "/merchant/" + this.tenantKey + "/customer/" + this.userId + "/invoice"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.post(locUrl, request, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    makeQCPayment(invoiceDetails,request){
        let locUrl = this.baseUrl + "/payment-service/api/" + this.applicationKey + "/merchant/" + this.tenantKey + "/" + invoiceDetails.estimateNumber + "/payment"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.post(locUrl, request, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    userCoupon(userKey,code){
        let locationKey = this.storageService.getItem("locationKey");
        if(locationKey.includes('"')){
            locationKey = JSON.parse(locationKey)
        }
        let locUrl = this.userServiceUrl + "/api/v3/" + this.tenantKey + "/" + locationKey + "/" + userKey + "/couponCode/" + code 
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(locUrl, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    validateCoupon(userKey,code){
        let locationKey = this.storageService.getItem("locationKey"); 
        if(locationKey.includes('"')){
            locationKey = JSON.parse(locationKey)
        }
        let locUrl = this.userServiceUrl + "/api/v3/" + this.tenantKey + "/" + locationKey + "/" + userKey + "/couponCode/" + code + "/" + userKey
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(locUrl, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    getTrainingExternal(organizationKey:any){
        let locationKey = this.storageService.getItem("locationKey");
        if(locationKey && locationKey.includes('"')){
            locationKey = JSON.parse(locationKey)
        }
        let locUrl = this.userServiceUrl + "/api/v3/" + organizationKey + "/" + this.tenantKey + "/external/groupBasedServices?active=true&showServicesWithPriceExists=true&size=500"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(locUrl, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    getSessions(organizationKey:any,serviceId:any){
        let locationKey = this.storageService.getItem("locationKey");
        if(locationKey.includes('"')){
            locationKey = JSON.parse(locationKey)
        }
        let locUrl = this.userServiceUrl + "/api/v3/external/" + organizationKey + "/" + this.tenantKey + "/groupBasedServices/" + serviceId + "/sessions?loadClasses=true&size=500"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(locUrl, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    checkPetAlreadyEnrolled(pet:any, session:any,organizationKey:string,userKey){
        let locUrl = this.userServiceUrl + "/api/v3/" + organizationKey + "/" + this.tenantKey + "/" + userKey + "/groupBasedServices/sessionsByCriteria?size=200&sort=createdOn,desc&petKey="+ pet.petKey + '&groupBasedSessionId=' + session.id
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(locUrl, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    getVeterinarianDate(organizationKey: any, userKey: any) {
        let locationKey = this.storageService.getItem("locationKey");
        if (locationKey && locationKey.includes('"')) {
            locationKey = JSON.parse(locationKey)
        }
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/" + userKey + "/veterinarians?sort=name,asc&size=1000"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(locUrl, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    addVeterinarian(data:any){
        let locationKey = this.storageService.getItem("locationKey");
        if (locationKey.includes('"')) {
            locationKey = JSON.parse(locationKey)
        }
        let locUrl = this.userServiceUrl + "/api/v2/" + this.tenantKey + "/" + locationKey + "/" + this.userId + "/veterinarians"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.post(locUrl, data, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    updateUserDetail(details: any) {
        let locUrl = this.userServiceUrl + "/users/" + details.userKey
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.put(locUrl, details, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    updateUserPreference(userKey: any, data: any) {
        let locUrl = this.userServiceUrl + "/users/" + userKey + "/preference"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.post(locUrl, data, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    getAttachments(documentId: any) {
        let locUrl = this.userServiceUrl + "/api/v3/"+ this.tenantKey  +"/external/document/" + documentId + "?loadAll=true&loadUrl=true"
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(locUrl, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )
    }

    checkDuplicateAppointment(serviceID:any,startDate:any,endDate:any,petKey:any){
        let locUrl = this.userServiceUrl + '/search/'+ this.tenantKey  +'/appointments/pet/'+ petKey +'?sort=appointmentDate,desc&page=0&size=10&reservationTypes=' + serviceID + '&startsAfter=' + startDate + '&endsBefore=' + endDate;
        let headers = new HttpHeaders({
            "authorization": "Bearer " + this.accessToken,
            "Content-Type": "application/json",
        });
        return this.http.get(locUrl, { headers: headers })
            .pipe(
                map((res: Response) => res),
                catchError((error: any) => throwError(error || 'Server error'))
            )

    }
}
